// extracted by mini-css-extract-plugin
module.exports = {"oneClickChange":"CartAddLink_oneClickChange__1suIL","oneClickChangeText":"CartAddLink_oneClickChangeText__louXZ","disabled":"CartAddLink_disabled__OO_3y"};